import { PdOrderSummary } from "./pd-order-summary/PdOrderSummary.js";
//#region src/pd-order-summary/pd-order-summary.ts
var tag = "pd-order-summary";
if (!customElements.get(tag)) customElements.define(tag, PdOrderSummary);
//#endregion
export { PdOrderSummary };
